import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();

$(function() {

	const sliderTestimonial = {

		init: function() {
			this.testimonialSlider();
			this.boxesEqualHeightResponsive();
		},

		testimonialSlider: function() {
			const $slider = $('.js-testimonial-slider');

			const $originalSlides = $slider.children().clone();

			for (let i = 0; i < 5; i++) {
				$slider.append($originalSlides.clone());
			}

			const sliderConfig = {
				infinite: true,
				autoplay: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				centerMode: true,
				arrows: true,
				prevArrow: $('.js-testimonial-slider__arr-prev'),
				nextArrow: $('.js-testimonial-slider__arr-next'),
				dots: false,
				speed: 300,
				responsive: [
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 2,
							centerMode: false,
						}
					},
					{
						breakpoint: 575,
						settings: {
							slidesToShow: 1
						}
					}
				]

			};

			// Initialize slider with custom configuration
			sliders.initializeSlider('.js-testimonial-slider', sliderConfig);
		},

		boxesEqualHeightResponsive: function() {

			const setEqualHeights = () => {
				const $boxes = $('.js-testimonial-slider .testimonial-slider__box');

				$boxes.css('height', 'auto');

				if ($(window).width() < 768) {
					let maxHeight = 0;

					$boxes.each(function() {
						maxHeight = Math.max(maxHeight, $(this).outerHeight());
					});

					$boxes.height(maxHeight);
				}
			};

			setEqualHeights();

			$(window).on('resize', function() {
				setEqualHeights();
			});

			$('.js-testimonial-slider').on('setPosition afterChange', function() {
				setEqualHeights();
			});
		}

	};

	sliderTestimonial.init();

});
